import { useQuery } from '@tanstack/react-query';
import { fetchInternalOrderById } from '@/api/orders';
import type { InternalOrderDetail } from '@/api/orders/types';

export const internalOrderDetailKeys = {
  detail: (id: string) => ['orders', 'internal', 'detail', id] as const,
};

export function useInternalOrderDetail(id: string) {
  return useQuery<InternalOrderDetail>({
    queryKey: internalOrderDetailKeys.detail(id),
    queryFn: () => fetchInternalOrderById(id).then(res => res.data),
    staleTime: 30_000,
    enabled: !!id,
  });
}
